(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mae-editorial-header"]) return;
  try {
    
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.me-header details[open]').forEach(function(d){d.open=false;d.querySelector('summary').focus()})}});document.addEventListener('click',function(e){document.querySelectorAll('.me-header details[open]').forEach(function(d){if(!d.contains(e.target))d.open=false})});
document.addEventListener('cart:updated',function(event){var count=event.detail&&event.detail.cart&&event.detail.cart.item_count;if(typeof count==='number'){document.querySelectorAll('[data-mae-cart-count]').forEach(function(el){el.textContent='('+count+')'})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mae-tiktok-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mae-tiktok-carousel')) {
  customElements.define('mae-tiktok-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.mae-tiktok__track');
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('article');
        if (!card) return;
        track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
